<div class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 h-100">
  <div class="w-lg-500px d-flex justify-content-center mb-5">
    <img src="assets/media/diabet-logo.png" class="w-250px" alt="Logo" />
  </div>
  <img
    class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-600px mt-lg-1 mb-10 mb-lg-10"
    src="assets/media/login-final.png"
    alt="login final"
  />
  <h1 class="d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7">
    Dialogic.Health
  </h1>
  <div class="d-none d-lg-block text-white fs-base text-center">
    {{ "descriptionText" | translate }}<br />
    v0.1.0 {{ currentYear }}
  </div>
</div>
